import { render } from "./TopNote.vue?vue&type=template&id=397889a0&scoped=true"
const script = {}

import "./TopNote.vue?vue&type=style&index=0&id=397889a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397889a0"]])

export default __exports__